export function onUpdateRouter() {
  if (!this.state.location) {
    return;
  }

  const location = this.state.location || {};
  const state = location.state || {};

  const { preserveScroll = false } = state;

  if (!preserveScroll) {
    window.scrollTo(0, 0);
  }
}

export const preserveScroll = {
  state: {
    preserveScroll: true,
  },
};
